import React, { ReactElement } from "react"
import { Link } from "gatsby"
import { isExternal } from "../utils/url"

export interface CTAProps {
  color: string
  isTransparent?: boolean
  openInNewTab?: boolean
  url: string
  children: ReactElement
}

const CallToAction = (props: CTAProps) => {
  const openLinkInNewTab = props.openInNewTab || isExternal(props.url)
  const targetProps = openLinkInNewTab
    ? {
        target: "_blank",
        rel: "noreferrer",
      }
    : null

  return openLinkInNewTab ? (
    <a
      className={`c-cta -${props.color} ${
        props.isTransparent ? "-outline" : ""
      }`}
      href={props.url}
      {...targetProps}
    >
      {props.children}
    </a>
  ) : (
    <Link
      className={`c-cta -${props.color} ${
        props.isTransparent ? "-outline" : ""
      }`}
      to={props.url}
    >
      {props.children}
    </Link>
  )
}

export default CallToAction
